import React, { FC, useState } from 'react';
import { QueryClient } from '@tanstack/react-query';
import { createQueryClient, QueryClientProvider } from '../../queryClient';
import { Widget, WidgetProps } from './Widget';
import { PortfolioWidgetContextProvider, PortfolioWidgetContextProviderProps } from './PortfolioWidgetContext';

export interface PortfolioWidgetProps extends PortfolioWidgetContextProviderProps, WidgetProps {
  queryClient?: QueryClient;
}

export const PortfolioWidget: FC<PortfolioWidgetProps> = ({
  username,
  queryClient,
  queryClientDehydratedState,
  servicesConfig,
  cardSize,
  thumbnailsPosition,
  thumbnailsAmount,
  roleIds,
  roles,
  fallback,
  biEnrichment,
  projectSource,
  subCategoryId,
  inAttachmentReportRollout,
}) => {
  const [client] = useState(queryClient || createQueryClient());

  return (
    <QueryClientProvider client={client} dehydratedState={queryClientDehydratedState}>
      <PortfolioWidgetContextProvider
        username={username}
        roleIds={roleIds}
        roles={roles}
        projectSource={projectSource}
        subCategoryId={subCategoryId}
        queryClientDehydratedState={queryClientDehydratedState}
        servicesConfig={servicesConfig}
        biEnrichment={biEnrichment}
        inAttachmentReportRollout={inAttachmentReportRollout}
      >
        <Widget
          cardSize={cardSize}
          thumbnailsAmount={thumbnailsAmount}
          thumbnailsPosition={thumbnailsPosition}
          fallback={fallback}
        />
      </PortfolioWidgetContextProvider>
    </QueryClientProvider>
  );
};

/**
 * This is required for lazy load component, do not use it directly.
 */
export default PortfolioWidget;
